import React, { useState } from "react";
import Form from "@Components/Form";
import { ATTENDANCE_URL, REMARKS_URL, URLS } from "configs/constants";
import * as Yup from "yup";


const status = [
  {
    id: "Absent",
    name: "Absent",
  },
  {
    id: "Present",
    name: "Present",
  },

];


const validationSchema = Yup.object({
  status: Yup.string()
  .required("Status is required")
  .typeError("Status is required"),
  remarks_id: Yup.string()
    .required("Type of Attendance is required")
    .typeError("Type of Attendance is required"),
});

const AttendanceEditForm = () => {


  const initialValues = {
    status: "",
    remarks_id: "",
    remarks_reason: "",
    mobile_clock_in_time: "",
    mobile_clock_out_time: "",
    server_clock_in_time: "",
    server_clock_out_time: "",
  };

 
  const formFields = [
    {
      type: "title",
      title: "Worker Details",
    },
    {
      type: "renderonly",
      label: "Worker ID",
      key: "employee_id",
    },
    {
      type: "renderonly",
      label: "Worker",
      key: "name",
    },
    {
      type: "renderonly",
      label: "Mobile No.",
      key: "mobile_number",
    },
    {
      type: "renderonly",
      label: "Supervisor",
      key: "supervisor",
    },
    {
      type: "renderonly",
      label: "Company",
      key: "company",
    },
    {
      type: "renderonly",
      label: "Zone",
      key: "zone",
    },
    {
      type: "renderonly",
      label: "Region",
      key: "region",
    },
    {
      type: "renderonly",
      label: "Estate",
      key: "estate",
    },
    {
      type: "renderonly",
      label: "Division",
      key: "division",
    },
    {
      type: "renderonly",
      label: "Block",
      key: "block",
    },

    {
      type: "title",
      title: "Attendance Details",
    },
    {
      type: "renderonly",
      label: "Date",
      date: true,
      key: "attendance_date",
    },
    {
      type: "renderonly",
      label: "Today Status",
      key: "today_status",
    },
    {
      type: "renderonly",
      label: "Today Clock In Time",
      key: "today_clock_in",
    },
    {
      type: "renderonly",
      label: "Today Clock Out Time",
      key: "today_clock_out",
    },
    {
      type: "renderonly",
      label: "Server Clock In Time",
      key: "server_clock_in_time",
    },
    {
      type: "renderonly",
      label: "Server Clock Out Time",
      key: "server_clock_out_time",
      gridSize: { xs: 12, sm: 6, md: 6, lg: 3 },
    },
    {
      type: "timepicker",
      name: "mobile_clock_in_time",
      autoComplete: "off",
      size: "small",
      helperText: "",
      label: "Mobile Clock In",
      gridSize: { xs: 12, sm: 6, md: 6, lg: 3 },
      emptyLabel: "",
    },
    {
      type: "timepicker",
      name: "mobile_clock_out_time",
      autoComplete: "off",
      size: "small",
      helperText: "",
      label: "Mobile Clock Out",
      gridSize: { xs: 12, sm: 6, md: 6, lg: 3 },
      spacing: 2,
      emptyLabel: "",
    },
    {
      type: "renderonly",
      label: "Total Working Hours",
      key: "total_working_hour",
    },
    {
      type: "renderonly",
      label: "Offline Sync Date-Time",
      key: "offline_sync_date",
      valueType: "date_time",
    },
    {
      name: "status",
      label: "Status",
      type: "reactselect",
      outerOptions: status,
      required: true,
      gridSize: { xs: 12, sm: 6, md: 6, lg: 3 },
    },
    {
      name: "remarks_id",
      label: "Type of Attendance",
      type: "reactselect",
      required: true,
      proxyUrl: REMARKS_URL,
      paginated: true,
      optionsDependsOn: "status",
      gridSize: { xs: 12, sm: 6, md: 6, lg: 3 },
    },
    {
      name: "remarks_reason",
      label: "Others-Please Specify",
      type: "input",
      renderKey: "remarks_id",
      renderValue: 20000,
      required: true,
    },
  ];
  const formButtons = ["submit", "cancel"];

  return (
    <Form
      initialValues={initialValues}
      submitUrl={ATTENDANCE_URL}
      formFields={formFields}
      listRoute={URLS.ATTENDANCE_LIST}
      formButtons={formButtons}
      formTitle="Attendance"
      validationSchema={validationSchema}
    />
  );
};

export default AttendanceEditForm;
